import EmployeeManagement from "../../../pages/employees/EmployeeManagement";

export default function EmployeesPage() {
  return <EmployeeManagement />;
}
